export default __webpack_public_path__ + "static/media/illustration-algowork-m.0964bcfe.webp";